import GameHistoryDetailsModal from './game-history-modal';

export default GameHistoryDetailsModal;
